module.exports = {
  "btn": {
    "position": "relative",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "#ffffff"
  },
  "btn-img-container": {
    "position": "absolute",
    "left": 0,
    "top": 0,
    "bottom": 0,
    "right": 0,
    "justifyContent": "center",
    "alignItems": "center"
  },
  "btn-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "32",
    "color": "#232323"
  },
  "dot-triangle": {
    "position": "absolute",
    "right": "10",
    "bottom": "10",
    "width": "24",
    "height": "24",
    "opacity": 0.5
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-07569f6c!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-circle-button/index.vue
// module id = 424
// module chunks = 0 1